export default __webpack_public_path__ + "static/media/Салбар_уулзалт_Багшийн_хөгжил,_хичээл_практикийн_1652850907.b2beb814.pdf";